export const CONSTANS = Object.freeze({
  PR_CHAN_CD: "PF100",
  PR_PRICE: "3600",
  SG_CHAN_CD: "SF100",
  SG_PRICE: "2000",
  TELE_CO_CD_NM: {
    1: "SKT",
    2: "KT",
    3: "LGU"
  },
  TELE_CO_CD: {
    SKT: "1",
    KT: "2",
    LGU: "3"
  }
});

// 홈페이지 개인정보처리방침(/privacy) 조회 슬롯.
// 모든 서비스가 동일한 통합 처리방침을 게시하므로 세이프가드 SKT 슬롯을 조회한다.
export const PRIVACY_POLICY_TERMS = Object.freeze({
  termsCd: "003",
  prdtNo: "A001",
  teleCoCd: "1"
});